import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "../lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    const raw = localStorage.getItem("tasklio_user");
    return raw ? JSON.parse(raw) : null;
  });
  const [loading, setLoading] = useState(true);

  const refreshMe = useCallback(async () => {
    const token = localStorage.getItem("tasklio_token");
    if (!token) {
      setUser(null);
      setLoading(false);
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      localStorage.setItem("tasklio_user", JSON.stringify(data));
    } catch {
      localStorage.removeItem("tasklio_token");
      localStorage.removeItem("tasklio_user");
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refreshMe();
  }, [refreshMe]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("tasklio_token", data.token);
    localStorage.setItem("tasklio_user", JSON.stringify(data.user));
    setUser(data.user);
    return data.user;
  };

  const register = async (email, password, business_name, acquisition_source, language) => {
    // `acquisition_source` is optional. When provided (from a /free?source=…
    // landing), it's persisted on the user record for attribution analytics.
    // `language` ("en"/"es") localizes the welcome email and seeds the
    // owner's saved language preference.
    const payload = { email, password, business_name };
    if (acquisition_source) payload.acquisition_source = acquisition_source;
    if (language === "en" || language === "es") payload.language = language;
    const { data } = await api.post("/auth/register", payload);
    localStorage.setItem("tasklio_token", data.token);
    localStorage.setItem("tasklio_user", JSON.stringify(data.user));
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("tasklio_token");
    localStorage.removeItem("tasklio_user");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, loading, login, register, logout, refreshMe }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
